<template>
  <div>
    <div v-if="loading" class="text-center p-5">Loading memo...</div>

    <div v-else>
      <div v-if="memo.length === 0" class="text-center text-muted p-4 border rounded">
        No memo available.
      </div>

      <table v-else class="table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Title</th>
            <th>Description</th>
          
            <th>URL</th>
            <th class="text-end">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in memo" :key="item.Id">
             <td>
              <div v-if="item.urlImage">
                <a :href="item.urlImage" target="_blank" title="View Image">
                  <img
                    :src="item.urlImage"
                    alt="Memo Thumbnail"
                    style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;"
                  />
                </a>
              </div>
              <div v-else class="text-muted small">No image</div>
            </td>
            <td>{{ item.Title }}</td>
            <td>{{ item.Description | truncate(60) }}</td>

           

            <td>
              <a :href="item.Url" target="_blank">{{ item.Url | truncate(40) }}</a>
            </td>

           

            <td>
              <div class="d-flex justify-content-end align-items-center gap-2">
                <img
                  src="../../assets/img/edit-btn.png"
                  width="30px"
                  class="mr-1"
                  @click="editMemo(item)"
                />
                <img
                  src="../../assets/img/delete-btn.png"
                  width="30px"
                  @click="deleteMemo(item.Id)"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- 🧩 Memo Popup -->
      <div v-if="openMemoPopup" class="upload-popup-overlay" @click.self="closeMemo">
        <div class="upload-popup-card">
          <button class="close-btn" @click="closeMemo">×</button>
          <h4 class="popup-title text-left">{{ editMode ? "Edit Memo" : "Add Memo" }}</h4>

          <div class="text-left mt-3">
            <label>Title</label>
            <CInput v-model="titleMemo" type="text" placeholder="Enter title..." />
          </div>

          <div class="text-left mt-3">
            <label>Description</label>
            <textarea
              v-model="descriptionMemo"
              class="form-control"
              placeholder="Enter description..."
              rows="3"
            ></textarea>
          </div>

          <div class="text-left mt-3">
            <label>URL</label>
            <CInput v-model="link" type="text" placeholder="Enter URL..." />
          </div>

          <!-- Image Upload -->
          <div
            class="upload-dropzone mt-3"
            @click="triggerFileInputMemo"
            @dragover.prevent
            @drop.prevent="handleDrop"
          >
            <input
              type="file"
              ref="fileInputMemo"
              @change="handleFilesMemo"
              accept=".png,.jpg,.jpeg"
              style="display:none"
            />

            <div v-if="previewUrlMemo" class="image-preview">
              <img :src="previewUrlMemo" alt="Preview" class="preview-img" />
            </div>

            <div v-else class="upload-content">
              <img src="../../assets/img/upload.png" alt="Upload Icon" class="upload-icon" />
              <p class="upload-text">Browse File</p>
              <p class="upload-subtitle">Choose a file or drag & drop it here</p>
            </div>
          </div>

          <div v-if="uploadedFileMemo" class="file-preview">
            <span class="file-name">
              <i class="fa fa-paperclip"></i> {{ uploadedFileMemo.name }}
            </span>
            <button class="remove-file" @click="removeFileMemo">×</button>
          </div>

          <button
            class="upload-submit-btn"
            :disabled="isUploading"
            @click="submitMemo"
          >
            {{ isUploading ? "Saving..." : editMode ? "Update Memo" : "Add Memo" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MemoList",
  data() {
    return {
      memo: [],
      loading: false,
      openMemoPopup: false, // ✅ missing before
      editMode: false,
      selectedMemoId: null,
      titleMemo: "",
      descriptionMemo: "",
      link: "",
      uploadedFileMemo: null,
      uploadedFileUrl: "",
      uploadedFileId: null,
      previewUrlMemo: "",
      isUploading: false,
    };
  },
  filters: {
    truncate(value, limit) {
      if (!value) return "";
      return value.length > limit ? value.substring(0, limit) + "..." : value;
    },
  },
  methods: {
    async loadMemo() {
      this.loading = true;
      try {
        const res = await this.$API.get(this.$GetListMemo);
        if (res.status === 200 && Array.isArray(res.data)) {
          this.memo = res.data.map(item => {
            if (item.urlImage && item.urlImage.startsWith("URL: "))
              item.urlImage = item.urlImage.replace(/^URL:\s*/, "");
            return item;
          });
        }
      } catch (err) {
        console.error("❌ Failed to load memos:", err);
      } finally {
        this.loading = false;
      }
    },

    // ✅ OPEN EDIT
    editMemo(memo) {
      this.editMode = true;
      this.selectedMemoId = memo.id;
      this.titleMemo = memo.Title;
      this.descriptionMemo = memo.Description;
      this.link = memo.Url;
      this.uploadedFileUrl = memo.urlImage;
      this.previewUrlMemo = memo.urlImage;
      this.openMemoPopup = true;
    },

    // ✅ ADD NEW MEMO
    addMemo() {
      this.resetForm();
      this.editMode = false;
      this.openMemoPopup = true;
    },

    closeMemo() {
      this.openMemoPopup = false;
      this.resetForm();
    },

    resetForm() {
      this.selectedMemoId = null;
      this.titleMemo = "";
      this.descriptionMemo = "";
      this.link = "";
      this.uploadedFileMemo = null;
      this.uploadedFileUrl = "";
      this.previewUrlMemo = "";
      this.uploadedFileId = null;
    },

    triggerFileInputMemo() {
      this.$refs.fileInputMemo.click();
    },

    handleFilesMemo(e) {
      const file = e.target.files[0];
      if (file) {
        this.uploadedFileMemo = file;
        this.previewUrlMemo = URL.createObjectURL(file);
      }
    },

    removeFileMemo() {
      this.uploadedFileMemo = null;
      this.previewUrlMemo = "";
    },

    // ✅ SUBMIT ADD/EDIT
    async submitMemo() {
      try {
        this.isUploading = true;

        // Upload image if selected
        if (this.uploadedFileMemo) {
          const formData = new FormData();
          formData.append("files", this.uploadedFileMemo);
          const uploadRes = await this.$API.post(this.$UploadMemo, formData, {
            withCredentials: true,
            timeout: 600000,
          });
          const uploaded = uploadRes.data[0];
          if (uploaded.success) {
            this.uploadedFileId = uploaded.fileId;
            this.uploadedFileUrl = uploaded.fileUrl.replace(/^URL:\s*/, "");
          } else {
            alert("❌ Upload failed");
            return;
          }
        }

        const payload = {
          id: this.selectedMemoId || 0,
          title: this.titleMemo,
          description: this.descriptionMemo,
          url: this.link,
          urlToImage: this.uploadedFileUrl,
          fileAwsId: this.uploadedFileId,
          status: "Published",
        };

        await this.$API.post(this.$InsertMemo, payload, {
          withCredentials: true,
          timeout: 600000,
        });

        alert(this.editMode ? "✅ Memo updated successfully!" : "✅ Memo added successfully!");
        this.closeMemo();
        this.loadMemo(); // 🔄 refresh after save
      } catch (err) {
        console.error(err);
        alert("⚠️ Failed to save memo.");
      } finally {
        this.isUploading = false;
      }
    },

    // ✅ DELETE MEMO
    async deleteMemo(id) {
      if (!confirm("Are you sure you want to delete this memo?")) return;
      try {
        const res = await this.$API.post(this.$DeleteMemo, { id }, { withCredentials: true });
        if (res.data === true) {
          alert("🗑️ Memo deleted successfully!");
          this.loadMemo();
        }
      } catch (err) {
        console.error("❌ Delete failed:", err);
        alert("⚠️ Failed to delete memo.");
      }
    },

    // ✅ TOGGLE STATUS
    async toggleStatus(item) {
      item.isUpdatingStatus = true;
      try {
        const payload = {
          ...item,
          Status: !item.Status,
        };
        await this.$API.post(this.$InsertMemo, payload, { withCredentials: true });
        item.Status = !item.Status;
      } catch (err) {
        console.error("❌ Failed to toggle status:", err);
      } finally {
        item.isUpdatingStatus = false;
      }
    },
  },
  mounted() {
    this.loadMemo();
  },
};
</script>

<style scoped>
.btn-sm {
  padding: .25rem .5rem;
  font-size: .75rem;
  border-radius: .2rem;
}
.upload-popup-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.6);
  display: flex; align-items: center; justify-content: center;
  z-index: 1000;
}
.upload-popup-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  width: 400px;
  max-height: 90vh;
  overflow-y: auto;
}
.close-btn {
  border: none;
  background: transparent;
  font-size: 20px;
  float: right;
  cursor: pointer;
}
.preview-img {
  width: 100%;
  border-radius: 8px;
  margin-top: 10px;
}
</style>